import {
  FETCHING_HUB_STREAMS_REQUEST, FETCHING_HUB_STREAMS_SUCCEEDED, FETCHING_HUB_STREAMS_FAILED,
  FETCHING_STREAM_REQUEST, FETCHING_STREAM_SUCCEEDED, FETCHING_STREAM_FAILED,
  FETCHING_GROUP_REQUEST, FETCHING_GROUP_SUCCEEDED, FETCHING_GROUP_FAILED,
  SEARCHING_STREAMS_REQUEST, SEARCHING_STREAMS_SUCCEEDED, SEARCHING_STREAMS_FAILED,
  INVALIDATE_STREAMS_SEARCH
} from 'constants/actionTypes';

import { createAction } from 'redux-actions';
import axios from 'axios';
import buildUrl from 'build-url';
import { call, put, takeLatest } from 'redux-saga/effects';

const apiUrl = process.env.REACT_APP_API_URL;
const STREAMS_BASE_URL = `${apiUrl}/api/2.0/streams`;
const GROUP_BASE_URL = `${apiUrl}/api/2.0/groups`;
const HUB_STREAMS_URL = `${STREAMS_BASE_URL}/hub`;
const SEARCH_BASE_URL = `${apiUrl}/api/2.0/search`;

/*
* Fetch hub streams
*/
export const fetchStreams = createAction(FETCHING_HUB_STREAMS_REQUEST);
const fetchingStreamsSucceeded = createAction(FETCHING_HUB_STREAMS_SUCCEEDED);
const fetchingStreamsFailed = createAction(FETCHING_HUB_STREAMS_FAILED);

function* fetchHubStreamsSaga(action) {
  
  const fetchHubStreamsAPI = () => {
    return axios.get(HUB_STREAMS_URL).then(response => response.data);
  }

  try {
    const response = yield call(fetchHubStreamsAPI);
    yield put(fetchingStreamsSucceeded(response));
  } catch (error) {
    yield put(fetchingStreamsFailed(error));
  }
}

/*
* Fetch stream
*/
export const fetchStream = createAction(FETCHING_STREAM_REQUEST, (id) => id);
const fetchingStreamSucceeded = createAction(FETCHING_STREAM_SUCCEEDED);
const fetchingStreamFailed = createAction(FETCHING_STREAM_FAILED);

function* fetchStreamSaga(action) {
  const id = action.payload;

  let url = buildUrl(STREAMS_BASE_URL, {
    path: `${id}`
  });
 
  const fetchStreamAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchStreamAPI);
    yield put(fetchingStreamSucceeded({id,response}));
  } catch (error) {
    yield put(fetchingStreamFailed({id,error}));
  }
}

/*
* Fetch group
*/

export const fetchGroup = createAction(FETCHING_GROUP_REQUEST, (id) => id);
const fetchingGroupSucceeded = createAction(FETCHING_GROUP_SUCCEEDED);
const fetchingGroupFailed = createAction(FETCHING_GROUP_FAILED);

function* fetchGroupSaga(action) {
  const id = action.payload;
  
  let url = buildUrl(GROUP_BASE_URL, {
    path: `${id}`
  });
 
  const fetchGroupAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchGroupAPI);
    yield put(fetchingGroupSucceeded({id,response}));
  } catch (error) {
    yield put(fetchingGroupFailed({id,error}));
  }
} 

/*
  search streams
*/
export const searchStreams = createAction(SEARCHING_STREAMS_REQUEST, (query, filter, page, limit, hightlight) => {
  return { query, filter, page, limit, hightlight };
});
const searchingStreamsSucceeded = createAction(SEARCHING_STREAMS_SUCCEEDED, (query, response) => ({ query, response }));
const searchingStreamsFailed = createAction(SEARCHING_STREAMS_FAILED, (query, error) => ({ query, error }));

export const invalidateStreamsSearch = createAction(INVALIDATE_STREAMS_SEARCH);

function* searchStreamsSaga(action) {
  const { query, page, limit, hightlight, filter } = action.payload;

  let url = buildUrl(SEARCH_BASE_URL, {
    path: `streams/${page}`
  });

  var additionalFilters = filter || {};

  let param = {
    ...additionalFilters,
    query: query,
    limit: limit,
    highlight: hightlight
  }

  const searchStreamsAPI = () => {
    return axios({
      method: 'GET',
      url: url,
      params: param,
    }).then(response => response.data);
  }

  try {
    const response = yield call(searchStreamsAPI);
    yield put(searchingStreamsSucceeded(query, response));
  } catch (error) {
    yield put(searchingStreamsFailed(query, error));
  }
}

export default function* streamsSaga() {
  yield takeLatest(FETCHING_HUB_STREAMS_REQUEST, fetchHubStreamsSaga);
  yield takeLatest(FETCHING_STREAM_REQUEST, fetchStreamSaga);
  yield takeLatest(FETCHING_GROUP_REQUEST, fetchGroupSaga);
  yield takeLatest(SEARCHING_STREAMS_REQUEST, searchStreamsSaga);
}; 
